<template>
  <canvas ref="myChart"></canvas>
</template>

<script>
import Chart from 'chart.js';

export default {
  // camel case not kebab case
  name: 'stats-horizontal-bar-chart',
  props: {
    labels: Array,
    datasets: {
      required: true,
    },
    graphType: {
      required: false,
    },
  },
  watch: {
    datasets(newDatasets) {
      this.chart.data.datasets = newDatasets;
      this.chart.update();
    },
    labels(newLabels) {
      this.chart.data.labels = newLabels;
      this.chart.update();
    },
    isStacked(newIsStacked) {
      this.chart.options.scales.yAxes[0].stacked = newIsStacked;
      this.chart.update();
    },
  },
  computed: {
    isStacked() {
      if (this.graphType === 'mission') {
        return false;
      }
      return true;
    },
    isReverse() {
      if (this.graphType === 'mission') {
        return false;
      }
      return true;
    },
    isTicks() {
      if (this.graphType === 'mission') {
        return false;
      }
      return true;
    },
  },
  mounted() {
    let taux = this.$t('statsChart.winsLabel');
    this.chart = new Chart(this.$refs.myChart, {
      type: 'horizontalBar',
      data: {
        labels: this.labels,
        datasets: this.datasets,
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          onClick: false,
          position: 'right',
          align: 'end',
          labels: {
            boxWidth: 45,
            fontSize: 14,
            padding: 20,
          },
        },
        tooltips: {
          backgroundColor: '#AEACAC',
          bodyFontSize: 13,
          callbacks: {
            // eslint-disable-next-line
            label: function (tooltipItem, data) {
              if (
                data.datasets[0].label === taux &&
                tooltipItem.datasetIndex === 0
              ) {
                // que pour les graph onglet mission && datasets des taux de réussite
                let div = data.datasets[1].data[tooltipItem.index];
                let percent =
                  (data.datasets[0].data[tooltipItem.index] / div) * 100;
                percent = Math.round(percent);
                return (
                  data.datasets[tooltipItem.datasetIndex].label +
                  ': ' +
                  percent +
                  '%'
                );
              }
              return (
                data.datasets[tooltipItem.datasetIndex].label +
                ': ' +
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              );
            },
          },
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false,
                offsetGridLines: true,
              },
              ticks: {
                reverse: this.isReverse,
                maxRotation: 0,
                autoSkipPadding: 10,
                display: this.isTicks,
              },
            },
          ],
          yAxes: [
            {
              stacked: this.isStacked,
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
                //borderDash: [20,5]
              },
            },
          ],
        },
      },
    });
  },
};
</script>
